<template>
  <div :class="['d-flex', alignClass]">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      :class="[
        'text-none text-body-1 font-weight-medium px-14 button-widget',
        !secondary
          ? 'white--text'
          : 'grey--text text--darken-4 button-widget-secondary',
      ]"
      height="48px"
      depressed
      rounded
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    secondary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alignClass() {
      const classes = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
      };

      return classes[this.align];
    },
  },
};
</script>

<style>
.button-widget {
  background: rgb(170, 28, 0);
  background: -moz-linear-gradient(
    0deg,
    var(--v-secondary-base) 0%,
    var(--v-secondary-lighten2) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    var(--v-secondary-base) 0%,
    var(--v-secondary-lighten2) 100%
  );
  background: linear-gradient(
    0deg,
    var(--v-secondary-base) 0%,
    var(--v-secondary-lighten2) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#aa1c00",endColorstr="#eb5107",GradientType=1);
}
</style>
